import React from 'react';
import { Dropdown } from 'react-bootstrap';

import { useWarehouseContext } from 'providers/WarehouseProvider';

const WarehouseDropdown = () => {
  const { warehouses, selectedWarehouse, setSelectedWarehouse, loading } =
    useWarehouseContext();

  const handleDropdownToggle = isOpen => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  };

  if (loading) {
    return (
      <div className="px-3 d-flex align-items-center">
        <div
          className="spinner-border spinner-border-sm text-primary"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <Dropdown onToggle={handleDropdownToggle}>
      <Dropdown.Toggle
        variant="falcon-default"
        className="text-truncate"
        style={{ maxWidth: '200px' }}
      >
        {selectedWarehouse?.name || 'Select Warehouse'}
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-menu-end" style={{ width: '200px' }}>
        {warehouses.map(warehouse => (
          <Dropdown.Item
            key={warehouse.id}
            onClick={() => setSelectedWarehouse(warehouse)}
            active={selectedWarehouse?.id === warehouse.id}
            className="text-truncate"
          >
            {warehouse.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default WarehouseDropdown;
